const firebaseConfig = {
	apiKey: 'AIzaSyAciGP6ejwZEMfwEvTtFk5-LQOo55KxU9Q',
	authDomain: 'native-chat-app-43424.firebaseapp.com',
	databaseURL: 'https://native-chat-app-43424.firebaseio.com',
	projectId: 'native-chat-app-43424',
	storageBucket: 'native-chat-app-43424.appspot.com',
	messagingSenderId: '285028646373',
	appId: '1:285028646373:web:72b47b2a58be071167830c',
	measurementId: 'G-G2QCKVE22P'
};

export default firebaseConfig;
